module.exports = __webpack_public_path__ + "static/media/DSC_0511.ec487ac0.jpg";